import type {UseMutationResult} from '@tanstack/react-query';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {CapacityDefault} from '@/types/CapacityDefault';
import {apiUrl} from '@/utils/api';

export const useUpdateCapacityDefault = () : UseMutationResult<
    void,
    unknown,
    CapacityDefault
> => {
    const fetch = useApiFetch();
    const queryClient = useQueryClient();

    return useMutation(async (values : CapacityDefault) => {
        try {
            await fetch(apiUrl('/v1/capacity/capacity/update-default').toString(), {
                method: 'PUT',
                body: JSON.stringify(values),
            });
        } catch (e : unknown) {
            throw new Error('Unable to update capacity default.');
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['capacityCombined']);
        },
    });
};
